import React, { useEffect } from "react";
import { ReactComponent as MultipleGroupsSvg } from "../../svg/GroupsSvg.svg";
import AddBox from "./AddBox";
import { BsFillCaretDownFill } from "react-icons/bs";
import ComponentHeader from "./ComponentHeader";
import moment from "moment";
import ApiConfig from "../../config/ApiConfig";
import { useNavigate } from "react-router-dom";
import ReactDatePicker from "react-datepicker";
import { forwardRef } from "react";
import { useState } from "react";
import Loader from "../../commonComponent/Loader";
import { sortArrLatest } from "../../Utils/Helper";
import { useDateTimezone } from "../../Context/DateTimezoneContext";
import SquareAvatar from "../../commonComponent/SquareAvatar";
import Avatar from "../../commonComponent/Avatar";

function Dash_Groups({ groups, isLoading }) {
  const navigate = useNavigate();
  const [calFilter, setCalFilter] = useState(new Date());
  const [groupss, setGroups] = useState(groups);
  const {dashboardDate} = useDateTimezone()

  useEffect(() => {                                                 //Filtering and SOrting Every data
    if (groups.length > 0) {
      const res = groups.sort((a, b) => new Date(a.updatedAt) - new Date(b.updatedAt))
      setGroups(sortArrLatest(groups));
    }
  }, [groups.length]);

  useEffect(() => {                                                 //Filter By Date Filter
    if (calFilter) filterGroupsbyDate(calFilter);
  }, [calFilter]);

  useEffect(() => {                                                 //Filter By Date Filter from Parent
    setCalFilter(dashboardDate)
  }, [dashboardDate]);


  // Calander DropDown
  const CustomDatePicker = forwardRef(({ value, onClick }, ref) => (
    <div className="d-flex align-items-center gap-1">
      {/* <span className="fw-semibold ms-2" style={{ fontSize: "18px", color:'rgba(31, 126, 120, 1)' }}>
        {(new Date(value).getDate() === new Date().getDate()
          ? "Today"
          : value) || "Today"}
      </span> */}
      <button className="btn" onClick={onClick} ref={ref}>
        {/* <span>{value}</span> */}
        <BsFillCaretDownFill color="rgba(31, 126, 120, 1)" />
      </button>
    </div>
  ));
  
  const filterGroupsbyDate = (date) => {
    const result = groups.filter((group) => {
      return (
        Date.parse(new Date(group?.createdAt).toDateString()) <=
        Date.parse(new Date(date).toDateString())
      );
    });
    setGroups(sortArrLatest(result))
  };

  return (
    <>
      <ComponentHeader
        title={"Groups"}
        filter={
          <ReactDatePicker
            dateFormat="MM-dd-yyyy"
            selected={calFilter}
            className="description_inputf mb-0"
            minDate={new Date("01-01-1720")}
            maxDate={new Date()}
            showMonthDropdown
            showYearDropdown
            yearDropdownItemNumber={300}
            scrollableYearDropdown
            onChange={(date) => setCalFilter(date)}
            customInput={<CustomDatePicker />}
            placeholderText="mm-dd-yyyy"
          />
        }
        descript={moment(new Date(calFilter)).format('MM-DD-YYYY') === moment(new Date()).format('MM-DD-YYYY') ? 'Today' : moment(new Date(calFilter)).format('MM-DD-YYYY')}
      />
      <div
        style={{ height: "200px", width:'100%', overflowY: "scroll", overflowX: "hidden"}}
        className={
          groups?.length > 0
            ? "Dash mb-5 d-flex flex-column justify-content-start align-items-center hover-overlay"
            : "Dash shadow rounded-4 mb-5 d-flex align-items-center"
        }
      >
        {isLoading ? (
          <center style={{ width: "100%" }}>
            {" "}
            <Loader
              visible={isLoading}
              style={{ top: "-15px", position: "relative" }}
            />
          </center>
        ) : groups?.length > 0 ? (
          groupss?.length > 0 ? (
            groupss?.map((group, index) => {
              return (
                <div
                  key={group._id}
                  className={
                    index === groupss?.length - 1
                      ? "my-1 pointer w-100 hover"
                      : "my-1 border-bottom pointer w-100 hover"
                  }
                  onClick={() =>
                    navigate("/groupactivities", {
                      state: { selectedGroup: group, isFromCreate: false },
                    })
                  }
                  style={{ borderColor: "rgba(240, 243, 248, 1)" }}
                >
                  <div className="row d-flex align-items-center px-3 py-2">
                    <div
                      className="col-sm-4 col-md-3 col-lg-2 d-flex justify-content-start "
                     
                    >
                      <Avatar
                      className="img-fluid "
                        src={
                          ApiConfig.ImageUrl +
                          "groups/" +
                          group.createdBy +
                          "/" +
                          group.groupImage
                        }
                        style={{
                          borderRadius: "50%",
                          height:'60px',
                          width:'60px'
                        }}
                        alt="..."
                        onError={(e) => {
                          e.target.src = "images/avatar.png"; //replacement image imported above
                        }}
                      />
                    </div>
                    <div className="col-lg-10 col-md-9 col-sm-8 ">
                      <div
                        className="p-2 d-flex flex-column justify-content-center "
                        style={{ width: "400px" }}
                      >
                        <span className="fw-bold resFont" >
                          {group?.groupName}
                        </span>
                        <span
                          className="fw-semibold p-0 m-0 resFont"
                          style={{
                            
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {group?.description}
                        </span>
                        <span
                          className="fw-semibold resFont"
                        >
                          <small className="text-muted">
                            Last {group.updatedAt ? "Updated" : "Created"}{" "}
                            {moment(
                              new Date(
                                group.updatedAt
                                  ? group?.updatedAt
                                  : group?.createdAt
                              )
                            ).fromNow()}
                          </small>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div
              className={
                "my-1 d-flex justify-content-center align-items-center h-100 w-100"
              }
              style={{ borderColor: "rgba(240, 243, 248, 1)" }}
            >
              <h4 className="">No record found</h4>
            </div>
          )
        ) : (
          <AddBox
            svg={<MultipleGroupsSvg />}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "transparent",
              cursor:'pointer'
            }}
            handleClick={() => {
              navigate("/groupadd");
            }}
            header="Create and begin to add groups by clicking"
            header2="here."
            content={""}
          />
        )}
      </div>
    </>
  );
}

export default Dash_Groups;
